import React, { useEffect, useState } from "react";

import { container, absolute, fixed, icon } from "./loader.module.scss";
import WandImg from "../../assets/images/svg/wand-loader.svg";

export interface ILoaderProps {
    className?: string;
    position?: "rel" | "absolute" | "fixed";
    texts?: string[];
}

const Loader: React.FC<ILoaderProps> = ({ className = "", position, texts = undefined }) => {
    const [textIdx, setTextIdx] = useState(0);

    useEffect(() => {
        if (!texts || texts.length === 0) return;
        const interval = setInterval(() => {
            setTextIdx((prev) => {
                if (prev < texts.length - 1) {
                    return prev + 1;
                }
                return prev;
            });
        }, 5000);
        return () => clearInterval(interval);
    }, [texts]);


    return (
        <div
            className={`
                ${container}
                ${className}
                ${genPositionClass(position)}
            `}
        >
            <WandImg className={icon} />
            {texts && texts.length > 0 && (
                <div style={{ marginTop: "20rem", textAlign: "center", color: "#CCAFCB", fontWeight: "bold" }}>
                    {texts[textIdx]}
                </div>
            )}
        </div>
    );
};

function genPositionClass(pos: ILoaderProps["position"]) {
    switch (pos) {
        case "fixed":
            return fixed;
        case "absolute":
            return absolute;
        case "rel":
        default:
            return "";
    }
}

export default Loader;
